import { useInView } from 'react-hook-inview';

import { isPrerenderIoBot, isSearchEngineBot } from 'src/utils/bots';

export type ViewportVisibility = {
  hasBeenVisible: boolean;
  isVisible: boolean;
  ref: ReturnType<typeof useInView>[0];
};

export type ViewportVisibilityOptions = {
  threshold?: number;
};

export default function useViewportVisibility({ threshold = 0 }: ViewportVisibilityOptions = {}): ViewportVisibility {
  const [ref, isVisibleConst] = useInView({ unobserveOnEnter: true, threshold });
  let isVisible = isVisibleConst;

  // Disable lazy loading for prerender.io bot and search engine bots
  if (isPrerenderIoBot() || isSearchEngineBot()) {
    isVisible = true;
  }

  // this is a legacy hook, so we need to keep it for now.
  const hasBeenVisible = isVisible;

  return { hasBeenVisible, isVisible, ref };
}
